module.exports = __webpack_public_path__ + "static/media/trenton.e2373394.png";